import React from "react";
import { UnitData } from "../../api/models/units";
import { useAppSelector } from "../../app/hooks";
import { selectLabels } from "../../slices/language";

interface UnitCardProps {
  unit: UnitData | null;
  style?: React.CSSProperties;
  onPress: () => void;
}

const UnitCard = ({ unit, style, onPress }: UnitCardProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <div className="card border-box gap-4" style={style} onClick={onPress}>
      <div className="w-100 border-box p-4">
        <p className="font-16 font-w-700 subtitle-color">
          {unit?.name}
        </p>
        <div
          className="w-100 border-box mt-4 p-4"
          style={{ border: "1px #e0e0e0 solid", borderRadius: 4 }}
        >
          <p className="subtitle-color font-14 mb-2">{labels.access_points}:</p>
          {unit?.access_points?.map((item, index) => (
            <p
              key={`${item?.id}-${index}`}
              className="subtitle-color font-14 font-w-500"
            >
              {item?.name}
            </p>
          ))}
        </div>
        <div className="w-100 border-box mt-4 flex justify-content-end">
          <p className="subtitle-color font-14">
            {labels.users}:{" "}
            <span className="font-w-700">
              {unit?.users?.length}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnitCard;
